import { post } from '@/utils/request'
import {get} from "../../utils/request";

// 应用管理-查询列表
export function getAppListAPI(data) {
    return post({
        data,
        url: 'version/app/admin/list'
    })
}

// 应用管理-查询app信息
export function getAppInfoByIdAPI(id) {
	return get({
		url: `version/app/admin/get/${id}`,
	})
}

// 应用管理-发布新应用
export function addAppAPI(data) {
    return post({
        data,
        url: 'version/app/admin/add'
    })
}

// 应用管理-修改应用
export function editAppAPI(data) {
    return post({
        data,
        url: 'version/app/admin/modify'
    })
}

// 应用管理-注销应用(参数传id和status即可)
export function cancelAppAPI(id) {
	return get({
		url: `version/app/admin/cancel/${id}`,
	})
}

// 应用管理-发布新版本
export function publishVersionAPI(data) {
    return post({
        data,
        url: 'version/app/admin/publishVersion'
    })
}

// 应用管理-查询版本信息
export function getAppVersionListAPI(data) {
    return post({
        data,
        url: 'version/app/admin/getVersions'
    })
}

// 应用管理-删除版本
export function deleteVersionAPI(id) {
	return get({
		url: `version/app/admin/deleteVersion/${id}`,
	})
}


// 应用管理-安装包检测
export function checkPackageAPI(data) {
    return post({
        data,
        url: 'file/file/upload/tbspackage'
    })
}


// 应用管理-发布新版本
export function publishNewVersionAPI(data) {
    return post({
        data,
        url: 'version/app/admin/publishVersionV2'
    })
}
